import { useEffect, useRef } from "react";

/**
 * Adds .in-view to elements with .reveal as they enter the viewport.
 * Single shared observer for performance.
 */
export default function useReveal() {
  const observerRef = useRef(null);

  useEffect(() => {
    if (typeof window === "undefined" || !("IntersectionObserver" in window)) {
      document.querySelectorAll(".reveal").forEach((el) => el.classList.add("in-view"));
      return;
    }

    const io = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("in-view");
            io.unobserve(entry.target);
          }
        });
      },
      { rootMargin: "0px 0px -10% 0px", threshold: 0.08 }
    );
    observerRef.current = io;

    const observeAll = () => {
      document.querySelectorAll(".reveal:not(.in-view)").forEach((el) => io.observe(el));
    };
    observeAll();

    // Re-scan when content changes (e.g., gallery filter)
    const mo = new MutationObserver(() => observeAll());
    mo.observe(document.body, { childList: true, subtree: true });

    return () => {
      io.disconnect();
      mo.disconnect();
    };
  }, []);
}
